import { observer } from 'mobx-react-lite'
import { Alert, type ITabItem, Tabs } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type IAlertProps } from 'shared/ui/Alert/types'
import { CountrySelect } from 'shared/ui/CountrySelect/CountrySelect'
import { type ChooseNumberTabsStore } from 'entities/Phone/ui/ChooseNumberTabs/store/ChooseNumberTabsStore'
import { type ITabsEnum } from 'entities/Phone/types'
import { ChooseNumberTabsContent } from './ChooseNumberTabsContent'
import { NoAvailableTabContent } from './NoAvailableTabContent'
import styles from './styles.module.scss'

type IGetNumberModalActionsProps = {
  store: ChooseNumberTabsStore
  alertProps?: IAlertProps | null
  className?: string
  editAnswers?: () => void
  showCountrySelectOverTabs?: boolean
  hideTabs?: boolean
  hideTabsContent?: boolean
  onClose?: () => void
}

export const ChooseNumberTabs = observer(
  ({
    store,
    alertProps,
    className,
    editAnswers,
    showCountrySelectOverTabs,
    hideTabs = false,
    hideTabsContent = false,
    onClose,
  }: IGetNumberModalActionsProps) => {
    const handleActiveTab = (item: ITabItem) => {
      const tabKey = item.key as ITabsEnum
      store.setActiveTab(tabKey)
    }

    return (
      <div aria-label={getAriaLabel('ChooseNumberTabsContent')} className={className}>
        {showCountrySelectOverTabs && <CountrySelect store={store.countryStore} />}
        {!hideTabs && (
          <div className={styles.tabs}>
            <Tabs
              tabs={store.tabs}
              activeTabKey={store.activeTab}
              handleSelectTab={handleActiveTab}
            />
          </div>
        )}
        {alertProps && <Alert {...alertProps} />}
        {!hideTabs && store.noAvailableText && editAnswers && (
          <NoAvailableTabContent infoText={store.noAvailableText} editAnswers={editAnswers} />
        )}

        {!hideTabsContent && !store.noAvailableText && (
          <ChooseNumberTabsContent
            store={store}
            hideCountrySelect={showCountrySelectOverTabs}
            onClose={onClose}
          />
        )}
      </div>
    )
  }
)
